module.exports = __webpack_public_path__ + "img/about_content_img4.2dcc1007.png";